export default __webpack_public_path__ + "static/landlord_dark-9dbd37fec404cb974837e41cc19eede9.png";